import { EventsListingFiltersState } from '../types';
import { ReduxState } from '../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {EventsListingFiltersState} The Event Listings Filters state.
 */
export const filtersSelector = (state) => state.eventsListing.nav.filters;
